import React from "react";

import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import { Container, HeroSection, HeroContentSection, HeroH1, HeroContent, NavContainer, HeroSubtitle } from "./styles";

import SEO from "~/components/SEO";
import createSchemaFaqForVaspPages from "~/components/SEO/schemas/createSchemaFaqForVaspPages";
import Products from "~/templates/network/components/Products";
import VaspPublicInfo from "~/templates/network/components/VaspPublicInfo";
import { VASP } from "~/types/vaspid";

type NetworkVaspPageServerSideProps = {
  nextVaspURL: string;
  previousVaspURL: string;
  vasp: VASP;
  isProductionEnv: boolean;
};

export default function NetworkVaspPage({
  vasp,
  nextVaspURL,
  previousVaspURL,
  isProductionEnv,
}: NetworkVaspPageServerSideProps) {
  return (
    <>
      <SEO
        title={`Is ${vasp.name} regulated & Travel Rule compliant? | Notabene`}
        description={`Is ${vasp.name} regulated & Travel Rule compliant? Find out more about ${vasp.name} & the Crypto Travel Rule using Notabene’s free VASP network!`}
        enableCrawlerIndex={isProductionEnv}
      >
        <script
          key="VaspFAQSchema"
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(createSchemaFaqForVaspPages(vasp.name)),
          }}
        />
      </SEO>

      <Container>
        <HeroSection>
          <HeroContent>
            <NavContainer>
              <Navbar inverted />
            </NavContainer>
            <HeroContentSection>
              <HeroH1 data-testid="h1-is-regulated">Is {vasp.name} regulated?</HeroH1>
              <HeroSubtitle>
                Find your transaction counterparty’s regulatory and Travel Rule status on Notabene’s VASP &amp; Crypto
                companies network.
              </HeroSubtitle>
            </HeroContentSection>
          </HeroContent>
        </HeroSection>
        <VaspPublicInfo vasp={vasp} nextVaspURL={nextVaspURL} previousVaspURL={previousVaspURL} />
        <Products />
        <Footer />
      </Container>
    </>
  );
}
